import { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Check, Download, RemoveCircleOutlineOutlined, Close } from "@mui/icons-material";
import { Grid, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton } from "@mui/material";
import { getDatabase, ref, update, onValue } from "firebase/database";
import { ModalStyle } from "../../util/Styles";
import { JsonToCsv } from "../../util/JsonToCsv";
import { startDate } from '../elements/DateRangePicker';
import { statusOptions } from "../../util/DataObject";

const Notification = (props) => {
  const history = useHistory();
	const [notifications, setNotifications] = useState([]);
	let info = localStorage.session ? JSON.parse(localStorage.session) : {};

  const updateDataFirebase = async (id) => {
    props.changeLoader(true);

    let user = localStorage.session ? JSON.parse(localStorage.session) : {};
    let uuid = user["uuid"];
    const db = getDatabase();
    await update(ref(db, `notificacion/${uuid}/${id}`), { active: false, checked: new Date().toJSON() });
    await getNotifications(info.uuid);

    props.changeLoader(false);
  };

  const getNotifications = async (uuid) => {
		let nots = [];
		let shows = [];
		const db = getDatabase();
		let reference = ref(db, `notificacion/${uuid}`)
		await onValue(reference, (snap) => {
			nots = [];
			shows = [];
			let data = snap.val();
			if(data){
				let key = Object.keys(data);
				for(let i = 0; i<key.length; i++){
					let n = data[key[i]];
					n['id'] = key[i];
					if(n['active']){
						nots.push(n);
						if(shows.length < 3){
							shows.push(n);
						}
					}
				}

			}
			setNotifications(JSON.parse(JSON.stringify(nots)));
		}, (error) => {
			console.log(error);
		});
		return nots;
	}

  const downloadExpedient = async (item) => {
    let data = item.path;
    let request = await API.service( "downloadFile", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status === 200) {
      if (request.data.data.response === "OK") {
        if (request.data.data.content) {
          updateDataFirebase(item.id);
          closelightbox();
          window.open(request.data.data.content, "Download");
        }
      }
    }
  };

  const openStatement = async (item) => {
    let data = item.path;
    updateDataFirebase(item.id);
    window.open(data, "_blank");
  };

  const downloadReport = async (item) => {
    updateDataFirebase(item.id);
    
    var dlAnchorElem = document.getElementById("downloadAnchorElem");
    dlAnchorElem.setAttribute("href", item.path);
    dlAnchorElem.setAttribute("download", "r27.json");
    dlAnchorElem.click();
    
    item.path && await downloadReportCSV(JSON.parse(decodeURIComponent(item.path.split(',')[1])));
  };
  
  const downloadReportCSV = async (doc) => {
    props.changeLoader(true);
    
    let newList = await doc["informacionSolicitada"].map((item) => {
      const id = item["identificacionReclamacion"];

      const getMonthName = (dateStr) => {
        if (!/^\d{8}$/.test(dateStr)) return null;
      
        const year = parseInt(dateStr.slice(0, 4));
        const month = parseInt(dateStr.slice(4, 6)) - 1;      
        const date = new Date(year, month);

        return {
          date: date.toLocaleString('es-ES', { month: 'long' }).charAt(0).toUpperCase() + date.toLocaleString('es-ES', { month: 'long' }).slice(1),
          q: Math.ceil((month + 1) / 3)
        }
      };

      const isFinished = doc.informacionSolicitada?.some(info =>
        info["identificacionReclamacion"].folioReclamacion === id["folioReclamacion"] && info["identificacionReclamacion"].estatusReclamacion === "102"
      );

      return {
        id_complaint: id["folioReclamacion"],
        udate_status: id["fechaActualizacionEstatus"],
        status_complaint: id["estatusReclamacion"],
        status_complaint_text: statusOptions.filter((i) => i.value === String(id["estatusReclamacion"]))[0]["label"],
        check: "",
        validation: isFinished ? "OK" : "Falta Concluir",
        month: getMonthName(id["fechaActualizacionEstatus"])["date"],
        q: getMonthName(id["fechaActualizacionEstatus"])["q"],
      }
    })

    let columns = [
        { header: "Folio albo", key: "id_complaint", width: 20 },
        { header: "Fecha actualización estatus", key: "udate_status", width: 20 },
        { header: "Código de Estatus", key: "status_complaint", width: 20 },
        { header: "Estatus de la reclamación", key: "status_complaint_text", width: 20 },
        { header: "Check", key: "check", width: 15 },
        { header: "Validación", key: "validation", width: 20 },
        { header: "Mes", key: "month", width: 15 },
        { header: "Q", key: "q", width: 15 },
    ];

    let specialCells = {
      iconRef: `F2:F${newList.length + 1}`,
      rules: [
        {
          type: 'expression',
          formulae: ['F2="OK"'],
          priority: 0,
          style: {
            font: { color: { argb: '38761D' }, bold: true },
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'CCFFCC' }}
          }
        },
        {
          type: 'expression',
          formulae: ['F2="Falta Concluir"'],
          priority: 0,
          style: {
            font: { color: { argb: 'B22222' }, bold: true },
            fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCFF' }}
          }
        },
      ]
    }

    let fileName = `R27-${startDate}`
    JsonToCsv(newList, columns, fileName, specialCells, true);
    props.changeLoader(false);
  };

  const ocultarNot = async (item) => {
    updateDataFirebase(item.id);
  };

  useEffect(() => {
    setNotifications(JSON.parse(JSON.stringify(props.data)));
  }, [props.data])

  return (
    <Dialog open={true} fullWidth>
      <ModalStyle property={String(false)}>
        <DialogTitle>
          Notificaciones
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} >
              Tienes {notifications.length} notificacion(es)      
              <hr />
            </Grid>
            
            {notifications.map((item, index) => {             
              return [
                <Grid item container spacing={2} key={`notification-${index}`} sx={{display: "flex", justifyContent: "space-between !important"}}>
                  <Grid item xs={9}>{item.message}</Grid>
                  {
                    item.type === "expediente-pm" && 
                    <Grid item xs={2} sx={{textAlign: "end"}}>
                    <IconButton sx={{padding: "0px"}} onClick={downloadExpedient.bind(this, item)}>
                      <Download />
                    </IconButton>
                    </Grid>
                  }
                  {
                    item.type === "statement-account" && 
                    <Grid item xs={2} sx={{textAlign: "end"}}>
                    <IconButton sx={{padding: "0px"}} onClick={openStatement.bind(this, item)}>
                      <Download />
                    </IconButton>
                    </Grid>
                  }
                  {
                    item.type === "report-r27" && 
                    <Grid item xs={2} sx={{textAlign: "end"}}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a href="#" id='downloadAnchorElem' style={{visibility: 'hidden', display: 'none'}}>Descargar</a>
                    <IconButton sx={{padding: "0px"}} onClick={downloadReport.bind(this, item)}>
                      <Download />
                    </IconButton>
                    </Grid>
                  }
                  {
                    (item.type === 'reassign-c-level' || item.type === 'assign-c-level' || item.type === 'cancelBatch' || item.type === 'blockUnblockBatch' || item.type === 'statement-send') &&
                    <Grid item xs={2} sx={{textAlign: "end"}}>
                      <IconButton sx={{padding: "0px"}} onClick={ocultarNot.bind(this, item)}>
                        <Check/>
                      </IconButton>
                    </Grid>
                  }
                  {
                    item.type.includes("error") && 
                    <Grid item xs={2} sx={{textAlign: "end"}}>
                      <IconButton sx={{padding: "0px"}} onClick={ocultarNot.bind(this, item)}>
                        <RemoveCircleOutlineOutlined />
                      </IconButton>
                    </Grid>
                  }
                  {
                    item.type === "info-r27" && 
                    <Grid item xs={2} sx={{textAlign: "end"}}>
                      <IconButton sx={{padding: "0px"}} onClick={ocultarNot.bind(this, item)}>
                        <RemoveCircleOutlineOutlined />
                      </IconButton>
                    </Grid>
                  }
                  {
                    (item.type === "blacklist") && 
                    <Grid item xs={2} sx={{textAlign: "end"}}>
                      <IconButton sx={{padding: "0px"}} onClick={ocultarNot.bind(this, item)}>
                        <RemoveCircleOutlineOutlined />
                      </IconButton>
                    </Grid>
                  }
                </Grid>
              ];
            })}
          </Grid>
        </DialogContent>
        <DialogActions> 
          <Button variant="contained" onClick={closelightbox} >Cerrar</Button>  
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default Notification;
